import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { MapPin, Calendar, ArrowLeft, Check } from "lucide-react";
import { endpoints } from "@/lib/api";
import { PageHero } from "./MarketingLayout";

export function MiniSalons() {
  const [salons, setSalons] = useState([]);
  useEffect(() => { endpoints.miniSalons().then(setSalons).catch(() => {}); }, []);
  return (
    <div>
      <PageHero eyebrow="Warm-up events" title="Mini Salons"
        subtitle="Two to three mini salons on the road to 2027. Display your build, vote for favourites and get a taste of what is coming." />
      <section className="max-w-7xl mx-auto px-6 pb-24 space-y-6">
        {salons.map((s, i) => (
          <Link to={`/mini-salons/${s.slug}`} key={s.id} data-testid={`minisalon-${i}`}
            className="group grid md:grid-cols-2 border border-white/10 card-hover overflow-hidden">
            <div className="aspect-[16/10] md:aspect-auto overflow-hidden">
              <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-8 flex flex-col justify-center">
              <div className="flex items-center gap-3 text-xs font-heading uppercase text-[#ffd600] mb-3">
                <span className="flex items-center gap-1"><Calendar size={13} /> {new Date(s.date).toLocaleDateString("en-AU", { month: "long", year: "numeric" })}</span>
                <span className="flex items-center gap-1"><MapPin size={13} /> {s.venue}</span>
              </div>
              <h2 className="font-display text-4xl sm:text-5xl uppercase text-white leading-none">{s.name}</h2>
              <p className="mt-3 text-[#8a8d91] font-body">{s.blurb}</p>
              <span className="mt-5 font-heading uppercase text-sm text-[#ff7a1a] group-hover:translate-x-1 transition-transform inline-flex items-center gap-1">View details →</span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}

export function MiniSalonDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);
  useEffect(() => { endpoints.miniSalon(slug).then(setS).catch(() => {}); }, [slug]);
  if (!s) return <div className="min-h-screen grid place-items-center text-[#8a8d91] font-heading uppercase">Loading...</div>;
  return (
    <div>
      <PageHero eyebrow={new Date(s.date).toLocaleDateString("en-AU", { month: "long", year: "numeric" })}
        title={s.name} image={s.image} subtitle={s.blurb} />
      <section className="max-w-4xl mx-auto px-6 pb-24">
        <Link to="/mini-salons" className="inline-flex items-center gap-2 text-[#8a8d91] hover:text-[#ff7a1a] font-heading uppercase text-sm mb-8"><ArrowLeft size={16} /> All mini salons</Link>
        <div className="border border-white/10 bg-[#121212] p-6 mb-8 flex flex-wrap gap-6">
          <div><div className="font-heading uppercase text-xs text-[#8a8d91]">Venue</div><div className="font-heading text-white">{s.venue}</div></div>
          <div><div className="font-heading uppercase text-xs text-[#8a8d91]">Month</div><div className="font-heading text-white">{new Date(s.date).toLocaleDateString("en-AU", { month: "long", year: "numeric" })}</div></div>
          <div><div className="font-heading uppercase text-xs text-[#8a8d91]">Status</div><div className="font-heading text-[#ff7a1a] uppercase">{s.status}</div></div>
        </div>
        <h3 className="font-display text-3xl uppercase text-white mb-4">What's on</h3>
        <div className="grid sm:grid-cols-2 gap-3">
          {s.highlights?.map((h, i) => (
            <div key={i} className="flex items-center gap-3 border border-white/10 bg-[#121212] px-4 py-3">
              <Check className="text-[#ffd600]" size={18} /><span className="text-white/90 font-body">{h}</span>
            </div>
          ))}
        </div>
        <a href="/#waitlist" className="pas-btn mt-10 text-base">Join the waitlist</a>
      </section>
    </div>
  );
}
